const validate = ({
  value,
  countryCode,
  isRequired,
  isValidNumber,
  disabled,
}: {
  value: string;
  countryCode: string | undefined;
  isRequired: boolean;
  isValidNumber: boolean;
  displayError?: boolean;
  disabled?: boolean;
}): string | null => {
  if (disabled) return null;

  if (value && !countryCode) {
    return 'Please select a country.';
  }

  if (isRequired && (!value || !countryCode || value === `+${countryCode}` || value === '+')) {
    return 'Required.';
  }

  if (!isValidNumber && !!value) {
    return 'Invalid phone number.';
  }

  return null;
};

export default validate;
